<template>
  <div class="jugend" id="jugend">
    <Header :menu-at="0" :headerTitle="'Jugendgruppe - Feuerwehr Pfaffenhofen'"/>
      <div class="container">
        <div class=" video-container">
          <iframe width="100%" height="420px" src="https://www.youtube.com/embed/3bM0i4dc9F4" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class="header-info-container">
          <p class="title">Jugendgruppe - Feuerwehr Pfaffenhofen</p>
          <p>Jeden Dienstag von 18:30 - 20:00 Uhr.</p>
        </div>
        <div class="content-container">
          <img class="image" src="youth/side_thumb_1.jpg" @click="showGallery('lightbox1')">
          <div class="content">
            <h1 class="title">Wir sind ...</h1>
            <p>… die Jugendfeuerwehr Pfaffenhofen. Unsere Gruppe trifft sich jeden Dienstagabend von <b>18:30 Uhr</b> bis <b>20:00 Uhr</b> im Feuerwehrgerätehaus Pfaffenhofen.</p>
          </div>
        </div>
        <LightBox :images="imageData1" :ref="'lightbox' + 1" :show-caption="false" :show-light-box="false"></LightBox>
        <div class="content-container reverse">
          <div class="content">
            <h1 class="title">Du suchst ...</h1>
            <p>… Gemeinschaft, Zusammenhalt und interessierst Dich für feuerwehrtechnische Geräte?</p>
            <div class="space"></div>
            <h1 class="title">Wir bieten…</h1>
            <p>	… neue Herausforderungen, gemeinsame Übungen, den Umgang mit modernen technischen Geräten und das Erlernen der Grundkenntnisse der Feuerwehr in Brandbekämpfung, Technischer-Hilfeleistung und Einsatzübungen.</p>
          </div>
          <img class="image" src="youth/side_thumb_2.jpg" @click="showGallery('lightbox2')">
        </div>
        <LightBox :images="imageData2" :ref="'lightbox' + 2" :show-caption="false" :show-light-box="false"></LightBox>
        <div class="content-container">
          <img class="image" src="youth/side_thumb_3.jpg" @click="showGallery('lightbox3')">
          <div class="content">
            <h1 class="title">Du erlebst…</h1>
            <p>… Jugend-Zeltlager, Sommerfest, Ausflüge, Wettkämpfe und viele weitere gemeinsame Aktivitäten.</p>
          </div>
        </div>
        <div class="end-content">
          <p class="first">Haben wir Dein Interesse geweckt und Du bist zwischen 12 und 17 Jahre alt?</p>
          <p class="second">Dann melde Dich gerne bei unseren Jugendwarten.</p>
        </div>
        <div class="about-us-container">
          <div class="person">
            <p class="name">Yannik Geisinger</p>
            <p class="active">Eintritt FFW 2011</p>
            <p class="role">Jugendwart, Truppführer</p>
            <div class="link-btn">
              <a href="mailto:yannik.geisinger@ff-pfaffenhofen.de" title="Email schreiben">
                <font-awesome-icon icon="envelope" />
              </a>
            </div>
          </div>
          <img class="image" src="youth/us.jpg" @click="showGallery('lightbox4')">
          <div class="person">
            <p class="name">Ziyade Looser</p>
            <p class="active">Eintritt FFW 2015</p>
            <p class="role">Jugendwartin, Gruppenführerin</p>
            <div class="link-btn">
              <a href="mailto:ziyade.looser@ff-pfaffenhofen.de" title="Email schreiben">
                <font-awesome-icon icon="envelope" />
              </a>
            </div>
          </div>
        </div>
        <LightBox :images="imageData3" :ref="'lightbox' + 3" :show-caption="false" :show-light-box="false"></LightBox>
        <LightBox :images="imageData4" :ref="'lightbox' + 4" :show-caption="false" :show-light-box="false"></LightBox>
        <div class="image-gallery ">
          <div class="pagination">
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
          <div class="swiper-wrapper">
            <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide  v-for="item in content" :key="item.title">
              <div class="wrapper">
                <div class="content">
                  <div class="image-container">
                    <img class="gallery-image" :src="item.cover_url">
                  </div>
                </div>
              </div>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-button-prev" slot="button-prev">
              <font-awesome-icon  class="slider-icon" icon="chevron-left"/>
            </div>
            <div class="swiper-button-next" slot="button-next">
              <font-awesome-icon class="slider-icon" icon="chevron-right"/>
            </div>
            </swiper>
          </div>
        </div>
      </div>
    <Footer />
    <Scroll2Top />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Scroll2Top from '@/components/Scroll2Top.vue'
import LightBox from 'vue-image-lightbox'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'youth',
  components: {
    Header, Footer, Scroll2Top, LightBox, swiper, swiperSlide
  },
  data: () => {
    return {
      imageData1: [
        {
          caption: "Caption 1",
          src: "youth/side_big_1.jpg",
          thumb: "youth/side_thumb_1.jpg"
        }
      ],
      imageData2: [
        {
          caption: "Caption 2",
          src: "youth/side_big_2.jpg",
          thumb: "youth/side_thumb_2.jpg"
        }
      ],
      imageData3: [
        {
          caption: "Caption 3",
          src: "youth/side_big_3.jpg",
          thumb: "youth/side_thumb_3.jpg"
        }
      ],
      imageData4: [
        {
          caption: "Caption 4",
          src: "youth/us.jpg",
          thumb: "youth/us.jpg"
        }
      ],
      content: [
        {
          cover_url: '/youth/gallery/0.jpg',
        },
        {
          cover_url: '/youth/gallery/1.jpg',
        },
        {
          cover_url: '/youth/gallery/2.jpg',
        },
                {
          cover_url: '/youth/gallery/3.jpg',
        },
        {
          cover_url: '/youth/gallery/4.jpg',
        },
        {
          cover_url: '/youth/gallery/5.jpg',
        }
      ],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        spaceBetween: 50,
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
          breakpoints: {
          950: {
            slidesPerView: 1
          },
        }
      }
    }
  },
  methods: {
    showGallery(ref) {
      const lightbox = this.$refs[ref]
      lightbox.showImage(0)
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

.debug {
  border: 1px dashed red;
}

.container {
  margin-top: 100px;

  p, h1 {
    color: $dark;
  }
}

.header-info-container {
  background: $light-0;
  box-shadow: $shadow-medium;
  border: 2px solid lighten($gray, 33%);
  padding: 12px;
  margin-bottom: 32px;

  p {
    text-align: center;
  }

  .title {
    font-weight: bolder;
    margin-bottom: -10px;
    font-size: 24px;
  }
}

.content-container {
  margin: 64px 0px; 
  display: grid;
  grid-template-columns: 1fr;

  @include tablet {
    grid-template-columns: 1fr 1fr;
  }

  @include max {
    grid-template-columns: 2fr 3fr;
  }

  .image {
    cursor: pointer;

    width: 90%;
    margin: 0 auto;

    @include tablet {
      height: 240px;
    }

    @include desktop {
      height: 300px;
    }
  }

  .content {

    align-self: center;
    padding-left: 20px;

    @include tablet {
      padding-left: 0px;
    }


    .title {
      font-size: 24px;
      margin-bottom: 10px;

      @include desktop {
        margin-bottom: 20px;
      }
    }

    p {
      font-size: 18px;
      opacity: 0.8;
    }

    margin-left: 20px;

    li {
      @include desktop {
        margin: 8px 0px;
        font-size: 18px;
      }
    }

    @include max {
      margin-left: 50px;
    }
  }

  .border {
    width: 2px;
    background: darken($light-1, 10%);
    margin: 0 32px;
    display: none;

    @include max {
      display: block;
    }
  }
}

.space {
  margin: 48px 0px;
}

.reverse {
  grid-template-columns: 1fr;

  @include tablet {
    grid-template-columns: 1fr 1fr;
  }

  @include max {
    grid-template-columns: 3fr 2fr;
  }

  .content {
    @include max {
      margin-left: 0px;
    }
  }

  .empty {
    display: none;

    @include max {
      display: block;
    }
  }
}

.about-us-container {
  display: grid;
  grid-template-columns: 1fr;
  @include tablet {
    grid-template-columns: 1fr 1fr 1fr;
  }

  background: $light-0;
  box-shadow: $shadow-light;
  border: 1px solid lighten($gray, 33%);

  .person {
    text-align: center;
    align-self: center;

    .name {
      font-size: 18px;
      font-weight: bold;
    }

    .active {
      margin-top: -12px;
      opacity: 0.8;
    }
  }

  .image {
    width: 100%;
    cursor: pointer;

    @include tablet {
      height: 300px;
      width: auto;
    }
  }
}

.image-gallery {
  margin: 64px 0px;
}

.gallery-image {
  width: 340px;
  
  @include desktop {
    width: 640px;
  }
}

.swiper-button-prev {
  background: none;
  left: 0px;
  top: 40%;
}

.swiper-button-next {
  background: none;
  top: 40%;
}

.swiper-pagination-bullet-active {
  background: $primary-0;
}

.swiper-pagination-bullet {
  margin: 0px 2px;
}


.pagination {
  margin-bottom: 25px;
}

.swiper-pagination {
  position: relative;

  @include desktop {
    text-align: center;
  }
}

.swiper-pagination-bullet {
  padding: 0px 5px;
}

.image-container {
  display: flex;
  align-content: center;
  justify-content: center;
}


.slider-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  color: $light-0;

  &:hover {
    opacity: 1;
    color: $primary-0;
  }

  opacity: 0.7;

  @include mini {
    color: $dark;
  }
}

.link-btn {
  width: 100%;
  padding: 20px 0 40px 0;

  a {
    color: $dark;
    opacity: 0.8;
    padding: 12px 15px;
    border-radius: 100%;
    background: darken($light-1, 4%);

    &:hover {
      opacity: 1;
      color: $primary;
    }
  }
}

.end-content {
  text-align: center;
  font-weight: 600;
  margin: 48px 0px;

  .first {
    font-size: 18px;
  }

  .second {
    font-size: 24px;
    margin-top: -12px;
  }
}
</style>